import { store } from '@betacrew/jars-flux'
export const componentKey = "STATEFILING";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setPayersList : (state, action) => {
            state.payersList = [...state.payersList, ...action.payload];
        },
        setSelectedPayer : (state, action) => {
            state.selectedPayer = action.payload;
        },
        setTaxYear : (state, action) => {
            state.taxYearsList = [...state.taxYearsList, ...action.payload];
        },
        setSelectedTaxYear : (state, action) => {
            state.selectedTaxYear = action.payload;
        },
        setForm : (state, action) => {
            state.formList = [...state.formList, ...action.payload];
        },
        setSelectedForm : (state, action) => {
            state.selectedForm = action.payload;
        },
        setHistory : (state, action) => {
            state.history = action.payload;
        },
        setTotalHistory : (state, action) => {
            state.totalHistory = action.payload;
        },
        setRowsPerPage : (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setSkip : (state, action) => {
            state.skip = action.payload;
        },
        setLoadingState : (state, action) => {
            state.loadingState = action.payload;
        },
    },
    initialReducerState: {
        payersList: [{label: 'Select Payer', value: 0}],
        selectedPayer: {label: 'Select Payer', value: 0},
        taxYearsList: [{label: 'Select Tax Year', value: 0}],
        selectedTaxYear: {label: 'Select Tax Year', value: 0},
        formList: [{label: 'Select Form', value: 0}],
        selectedForm: {label: 'Select Form', value: 0},
        history: [],
        totalHistory: 0,
        rowsPerPage: 10,
        skip: 0,
        loadingState: false,
    }
});
export const { setHistory, setSkip, setRowsPerPage, setLoadingState, setSelectedPayer, setPayersList, setTotalHistory, setTaxYear, setSelectedTaxYear, setForm, setSelectedForm } = actions;